import React, { useRef } from 'react';

import chevronDownSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-down-small';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import PlacementExportMenu from 'src/components/shared/placementExportMenu';
import useOpenCloseState from 'src/hooks/useOpenCloseState';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';

interface ActionsProps {
  placement: AssociateProfilePlacement;
}

const ExportActionMenu = ({ placement }: ActionsProps) => {
  const exportLinkRef = useRef<HTMLButtonElement>(null);
  const { isOpen: isExportMenuOpen, open: openExportMenu, close: closeExportMenu } = useOpenCloseState();

  return (
    <>
      <Button type="link" ref={exportLinkRef} onClick={openExportMenu}>
        Export <Icon tokens={chevronDownSmallTokens} />
      </Button>
      <PlacementExportMenu
        placementId={placement.accommodationId.toString()}
        anchorRef={exportLinkRef}
        isMenuOpen={isExportMenuOpen}
        closeMenu={closeExportMenu}
        newestJmrFileName={placement.newestJmrFileName}
        countryId={placement.site.countryId}
        allocatedJobShifts={placement.allocatedJobShifts}
        jobModificationsEnabled={placement.site.jobModificationsEnabled}
      />
    </>
  );
};

export default ExportActionMenu;
